<script setup lang="ts">
import FormCategoriaEspacoEvento from '../components/form-categoria-espaco-evento.vue'
import { useCategoriaEspacoEventoStore } from '../store/useCategoriaEspacoEventoStore'

definePage({
  meta: {
    navActiveLink: 'admin-categoria-espaco-evento',
    action: 'create',
    subject: 'categoriaespacoevento',
  },
})

const { resetForm } = useCategoriaEspacoEventoStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormCategoriaEspacoEvento />
</template>
